import { createSvgIcon } from "@mui/material/utils";

const UploadProfileIcon = createSvgIcon(
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3333 9.58317V12.1665C18.3333 14.0333 18.3333 14.9668 17.97 15.6798C17.6504 16.307 17.1405 16.8169 16.5133 17.1365C15.8002 17.4998 14.8668 17.4998 13 17.4998H6.99996C5.13312 17.4998 4.1997 17.4998 3.48666 17.1365C2.85945 16.8169 2.34952 16.307 2.02994 15.6798C1.66663 14.9668 1.66663 14.0333 1.66663 12.1665V7.83317C1.66663 5.96633 1.66663 5.03291 2.02994 4.31987C2.34952 3.69266 2.85945 3.18273 3.48666 2.86315C4.1997 2.49984 5.13312 2.49984 6.99996 2.49984H10.4166M15.8333 6.6665V1.6665M13.3333 4.1665H18.3333M13.3333 9.99984C13.3333 11.8408 11.8409 13.3332 9.99996 13.3332C8.15901 13.3332 6.66663 11.8408 6.66663 9.99984C6.66663 8.15889 8.15901 6.6665 9.99996 6.6665C11.8409 6.6665 13.3333 8.15889 13.3333 9.99984Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "UploadProfile"
);

export default UploadProfileIcon;
